import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Modal from 'react-modal';
import PropertyList from './components/PropertyList';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import Profile from './components/Profile';
import HouseDetail from './components/HouseDetail';
import ScenarioView from './components/ScenarioView';
import Dashboards from './components/Dashboards';
import Settings from './components/SettingsNew';
import Layout from './components/Layout';
import LandingPage from './components/LandingPage';
import Features from './components/Features';
import FAQs from './components/FAQs';
import Contact from './components/Contact';
import Pricing from './components/Pricing';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import './App.css';

// Set up Modal for the entire app
Modal.setAppElement('#root');

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/" />;
  }

  return children;
}

function App() {
  const AuthenticatedRoute = ({ children }) => {
    const { currentUser } = useAuth();
    return currentUser ? children : <LandingPage />;
  };

  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <div className="App w-100 min-vh-100">
            <Routes>
              <Route path="/features" element={<Features />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              
              <Route path="/" element={
                <AuthenticatedRoute>
                  <Layout>
                    <PropertyList />
                  </Layout>
                </AuthenticatedRoute>
              } />
            
              <Route path="/profile" element={
                <AuthenticatedRoute>
                  <Layout>
                    <Profile />
                  </Layout>
                </AuthenticatedRoute>
              } />
              
              <Route path="/dashboards" element={
                <AuthenticatedRoute>
                  <Layout>
                    <Dashboards />
                  </Layout>
                </AuthenticatedRoute>
              } />
              
              <Route path="/settings" element={
                <AuthenticatedRoute>
                  <Layout>
                    <Settings />
                  </Layout>
                </AuthenticatedRoute>
              } />
            
              <Route path="/property/:id" element={
                <AuthenticatedRoute>
                  <Layout>
                    <HouseDetail />
                  </Layout>
                </AuthenticatedRoute>
              } />
            
              <Route path="/scenario/:id" element={
                <AuthenticatedRoute>
                  <Layout>
                    <ScenarioView />
                  </Layout>
                </AuthenticatedRoute>
              } />
            </Routes>
          </div>
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
